import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import EditArticleDropdown from '../Dropdowns/EditArticleDropdown';
import withLocaleKnowledgeBaseLink from '../../utils/withLocaleKnowledgeBaseLink';
import getCurrentLanguage from '../../utils/getCurrentLanguage';
import app from 'flarum/forum/app';

export default class PeacefulArticleList extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    const language = getCurrentLanguage();

    // Load articles
    const params = {
      filter: {
        tag: this.attrs.currentTag.slug(),
      },
    };

    if (language) {
      params.filter['language'] = language;
    }

    app.discussions.refreshParams(params);
  }

  view() {
    const state = this.attrs.state;

    let loading = null;

    if (state.isInitialLoading() || state.isLoadingNext()) {
      loading = LoadingIndicator.component({
        containerClassName: 'Flarum-Support-LoadingBig',
      });
    } else if (state.hasNext()) {
      loading = Button.component(
        {
          className: 'Button',
          icon: 'fas fa-chevron-down',
          onclick: state.loadNext.bind(state),
        },
        app.translator.trans('core.forum.discussion_list.load_more_button')
      );
    }

    // No items
    if (state.isInitialLoading() && state.isEmpty()) {
      return (
        <div className="Support-Loader">
          <span>{app.translator.trans('v17development-flarum-support.forum.overview.loading_articles')}</span>
          <LoadingIndicator />
        </div>
      );
    }

    // No items
    if (state.isEmpty()) {
      return <div className="Support-Empty">{app.translator.trans('v17development-flarum-support.forum.overview.no_articles_found')}</div>;
    }

    const flag = app.initializers.has('fof/discussion-language') ? flarum.extensions['fof-discussion-language'].utils.flag : null;

    return (
      <div>
        {state.getPages().map((pg) => {
          return pg.items.map((article) => {
            const post = article.mostRelevantPost()
              ? article.mostRelevantPost().contentPlain()
              : article.firstPost() && article.firstPost().contentPlain();

            return (
              <div className="Category-Item-Container Hide-Dropdown-Controls">
                <div className="Support-Settings-Holder">
                  {(article.canRename() || article.canHide()) && <EditArticleDropdown article={article} onListPage={true} />}
                </div>

                <Link
                  href={withLocaleKnowledgeBaseLink('knowledgeBaseArticle', {
                    id: article.slug(),
                  })}
                  className="Category-Item Is-Sub-Item"
                >
                  <h4>
                    {app.initializers.has('fof/discussion-language') && getCurrentLanguage() === null ? flag(article.language()) : null}{' '}
                    {article.title() + (article.isHidden() ? ` (${app.translator.trans('v17development-flarum-support.forum.article.hidden')})` : '')}
                  </h4>

                  <p>{post.length > 100 ? post.substr(0, 100) + '...' : post}</p>
                </Link>
              </div>
            );
          });
        })}

        {loading && <div className="SupportSearchList-loadMore">{loading}</div>}
      </div>
    );
  }
}
